export default __webpack_public_path__ + "static/media/rightGray.2db327b2.svg";